import type { ReactNode } from 'react';
import {
    COLLAPSED_RAIL_WIDTH_PX,
    EXPAND_ICON,
    LABEL_TOOLTIP_SIDE,
    type SideRailSide
} from './sideRail';
import { SideRailVerticalLabel } from './SideRailVerticalLabel';

interface CollapsedSideRailProps {
    side: SideRailSide;
    panelName: string;
    label: string;
    secondaryLabel?: string;
    labelTooltip?: ReactNode;
    onExpand: () => void;
    leading?: ReactNode;
    trailing?: ReactNode;
}

function CollapsedSideRail({
    side,
    panelName,
    label,
    secondaryLabel,
    labelTooltip,
    onExpand,
    leading,
    trailing
}: CollapsedSideRailProps) {
    const ExpandIcon = EXPAND_ICON[side];
    const expandTitle = `Expand ${panelName}`;

    return (
        <aside
            className="bg-white border border-gray-200 rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.08)] flex flex-col flex-shrink-0 overflow-hidden"
            style={{ width: COLLAPSED_RAIL_WIDTH_PX }}
        >
            <button
                type="button"
                onClick={onExpand}
                className="flex items-center justify-center py-3 border-b border-gray-100 hover:bg-gray-50 text-gray-500 transition-colors flex-shrink-0"
                title={expandTitle}
                aria-label={expandTitle}
            >
                <ExpandIcon className="w-3.5 h-3.5" />
            </button>
            {leading && <div className="flex justify-center pt-3 flex-shrink-0">{leading}</div>}
            <div className="flex-1 flex flex-col items-center justify-start gap-2 py-3 relative">
                <SideRailVerticalLabel
                    label={label}
                    secondaryLabel={secondaryLabel}
                    tooltip={labelTooltip}
                    tooltipSide={LABEL_TOOLTIP_SIDE[side]}
                />
                {trailing && (
                    <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5">
                        {trailing}
                    </div>
                )}
            </div>
        </aside>
    );
}

export { CollapsedSideRail };
